export default "__VITE_ASSET__4bd5dd3b__"